import { render, staticRenderFns } from "./geochat-list-item.vue?vue&type=template&id=0513ed95&scoped=true"
import script from "./geochat-list-item.vue?vue&type=script&lang=ts"
export * from "./geochat-list-item.vue?vue&type=script&lang=ts"
import style0 from "./geochat-list-item.vue?vue&type=style&index=0&id=0513ed95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0513ed95",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBadge,VIcon})
